"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _useAddressSearch = require("../../hooks/questionnaire/useAddressSearch");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const QuestionWithAddressSearch = _ref => {
  var _question$minCharacte;
  let {
    question,
    selections
  } = _ref;
  const initialState = {
    address: '',
    streetNumber: ''
  };
  const minCharacters = (_question$minCharacte = question.minCharacters) !== null && _question$minCharacte !== void 0 ? _question$minCharacte : 3;
  const {
    addressSuggestions,
    state,
    onFilter,
    onSuggestionsSelect: onSelect,
    onFieldChange
  } = (0, _useAddressSearch.useAddressSearch)(question, initialState, selections);
  const regex = question.addressFiltrationRegex;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SearchSuggestionWithLabel, {
    fieldWrapper: {
      label: '',
      width: 'full'
    },
    searchSuggestion: {
      suggestions: addressSuggestions,
      value: state.address,
      type: 'text',
      id: 'address-search',
      placeholder: _services.Services.locale.localeString('Questionnaire.AddressSelectorPlaceholder'),
      minCharacters,
      onChange: value => onFieldChange('address', value),
      onSelect,
      handleFiltering: value => onFilter(value, regex)
    }
  }), !regex && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextInputWithLabel, {
    fieldWrapper: {
      label: '',
      width: 'full'
    },
    textInput: {
      type: 'text',
      id: 'address-street-number',
      placeholder: _services.Services.locale.localeString('Questionnaire.streetNumberPlaceholder'),
      value: state.streetNumber,
      onChange: event => onFieldChange('streetNumber', event.target.value)
    }
  }));
};
var _default = QuestionWithAddressSearch;
exports.default = _default;
QuestionWithAddressSearch.propTypes = {
  question: _propTypes.default.shape({
    minCharacters: _propTypes.default.number,
    addressFiltrationRegex: _propTypes.default.instanceOf(RegExp)
  }).isRequired,
  selections: _propTypes.default.array.isRequired
};